<button
  mat-icon-button
  aria-label="Anomalies"
  matTooltip="Anomalies"
  [matMenuTriggerFor]="anomaliesMenu"
  [matBadge]="inProgressCount()"
  [matBadgeHidden]="!inProgressCount()"
  matBadgeSize="small"
  [matBadgeDescription]="inProgressCount() + ' anomalies en cours'"
>
  <svg lucideTriangleAlert class="vanex-gold"></svg>
</button>

<ng-template #item let-item let-kind="kind" let-edit="edit">
  <span class="item">
    <span class="dot {{ kind }}"></span>
    <span class="text">
      <span class="item-title">{{ item.title }}</span>
      <span class="item-subtitle">{{ item.subtitle }}</span>
    </span>
    @if (edit) {
      <svg lucidePencil class="edit"></svg>
    }
  </span>
</ng-template>

<mat-menu #anomaliesMenu="matMenu" class="anomalies-menu">
  <ng-template #directionSection let-entries let-kind="kind" let-label="label">
    @if (entries.length) {
      <div class="section">{{ label }}</div>
      @for (entry of entries; track entry.id) {
        <button mat-menu-item (click)="openDialog(entry.anomaly)">
          <ng-container
            *ngTemplateOutlet="item; context: { $implicit: entry, kind: kind, edit: true }"
          ></ng-container>
        </button>
        @if (entry.reopenable) {
          <button mat-menu-item class="reopen" (click)="reopen(entry.id)">
            <svg lucideCornerDownRight></svg>
            <span>{{ reopenLabel(entry.reopenable) }}</span>
          </button>
        }
      }
    }
  </ng-template>

  <ng-template #userSection let-entries let-kind="kind" let-label="label">
    @if (entries.length) {
      <div class="section">{{ label }}</div>
      @for (entry of entries; track entry.id) {
        <button mat-menu-item (click)="reopen(entry.id)">
          <ng-container
            *ngTemplateOutlet="item; context: { $implicit: entry, kind: kind }"
          ></ng-container>
        </button>
      }
    }
  </ng-template>

  @if (isDirection) {
    @let sections = directionItems();
    <ng-container
      *ngTemplateOutlet="
        directionSection;
        context: { $implicit: sections.inProgress, kind: 'in-progress', label: 'En cours' }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        directionSection;
        context: { $implicit: sections.scheduled, kind: 'scheduled', label: 'Programmées' }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        directionSection;
        context: { $implicit: sections.resolved, kind: 'resolved', label: 'Résolues' }
      "
    ></ng-container>
  } @else {
    @let sections = userItems();
    <ng-container
      *ngTemplateOutlet="
        userSection;
        context: { $implicit: sections.inProgress, kind: 'in-progress', label: 'En cours' }
      "
    ></ng-container>
    <ng-container
      *ngTemplateOutlet="
        userSection;
        context: { $implicit: sections.resolved, kind: 'resolved', label: 'Résolues' }
      "
    ></ng-container>
    @if (!sections.inProgress.length && !sections.resolved.length) {
      <div class="section empty">Aucune anomalie en cours</div>
    }
  }

  <ng-container *appHasRole="authors">
    <mat-divider></mat-divider>
    <button mat-menu-item class="report" (click)="openDialog()">
      <svg lucidePlus></svg>
      <span>Signaler une anomalie</span>
    </button>
    <button
      mat-menu-item
      [matMenuTriggerFor]="archivedMenu"
      [disabled]="!directionItems().archived.length"
    >
      <svg lucideArchive></svg>
      <span>Archivées</span>
    </button>
  </ng-container>
</mat-menu>

<mat-menu #archivedMenu="matMenu" class="anomalies-menu">
  @for (entry of directionItems().archived; track entry.id) {
    <button mat-menu-item (click)="openDialog(entry.anomaly)">
      <ng-container
        *ngTemplateOutlet="item; context: { $implicit: entry, kind: 'archived', edit: false }"
      ></ng-container>
    </button>
  }
</mat-menu>
